import React, { useEffect, useState } from "react";

export const LoadingContext = React.createContext();

const LoadingProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [loadingElements, setLoadingElements] = useState([]);

    const addToLoading = (name) => {
        if (!loadingElements.includes(name)) setLoadingElements([...loadingElements, name]);
    };

    const removeFromLoading = (name) => {
        setLoadingElements(loadingElements.filter((item) => item !== name));
    };

    useEffect(() => {
        if (loadingElements.length === 0 && isLoading) setIsLoading(false);
        if (loadingElements.length > 0 && !isLoading) setIsLoading(true);
    }, [loadingElements]);

    const providerValue = React.useMemo(
        () => ({ isLoading, addToLoading, removeFromLoading }),
        [isLoading, addToLoading, removeFromLoading]
    );

    return <LoadingContext.Provider value={providerValue}>{children}</LoadingContext.Provider>;
};

export default LoadingProvider;
